import React from 'react';
const BroSplitPlan = () => {
  return (
    <div className="bro-split-plan-container" id="workoutplans">
      <div className="bro-split-content">
        <h1>Sweat out all those bad vibes with our ultimate Bro-Split Plan !</h1>
        <p>Follow the Bro Split plan and achieve your fitness goals. Each day is dedicated to a specific muscle group to maximize growth and recovery.</p>
        <div className="workout-buttons">
          <a className="workout-button" href="#chest">Chest Workout</a>
          <a className="workout-button" href="#back">Back Workout</a>
          <a className="workout-button" href="#leg">Leg Workout</a>
          <a className="workout-button" href="#shoulder">Shoulder Workout</a>
          <a className="workout-button" href="#arms">Arms Workout</a>
        </div>
      </div>
    </div>
  );
};

export default BroSplitPlan;
